export const CUSTOMER_USER_ROLE_LABELS = {
  CUSTOMER_MANAGER: { singular: 'Fleet Manager', plural: 'Fleet Managers' },
  OPERATOR: { singular: 'Operator', plural: 'Operators' },
  TECHNICIAN: { singular: 'Technician', plural: 'Technicians' },
};

export function normalizeCustomerUserRole(role) {
  return String(role || '').trim().toUpperCase();
}

export function customerUserRoleLabel(role, { plural = false } = {}) {
  const normalized = normalizeCustomerUserRole(role);
  const entry = CUSTOMER_USER_ROLE_LABELS[normalized];
  if (entry) return plural ? entry.plural : entry.singular;
  return normalized || 'User';
}
